


<!-- 
<button mat-button [routerLink]="'maintain'">
    Mes véhicules 
</button>
-->
<div class="section-titles"> 
    <button mat-button class="simple-button" [routerLink]="'account'">
        Mon compte
    </button> 

    <button mat-button class="simple-button" [routerLink]="'appointments'">
        Mes rendez vous 
    </button>

    <button mat-button class="simple-button" [routerLink]="'public'" [queryParams]="{ id: ''+this.currentUserId }">
        Mon profil public
    </button> 

    <button mat-button class="simple-button" [routerLink]="'activity-search'">
        Rechercher Activités
    </button> 
</div>
<router-outlet></router-outlet>
